module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wrapper",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "rightText"
  }, [_vm._v(_vm._s(_vm.rightText))])]), _vm._v(" "), _c('div', {
    staticClass: "right-arr"
  }, [(_vm.showClickIcon) ? _c('i', {
    staticClass: "icon"
  }, [_vm._v("")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-divide"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-15432479!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/info-item.vue
// module id = 826
// module chunks = 34